import { useState } from "react";
import { useMutation } from "react-query";
import { fetchGetTaskCounterTemplates } from "../miscellaneous/fetchGetTaskCounterTemplates";

export const useGetTaskCounterTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const mutationQueryTemplates = useMutation(fetchGetTaskCounterTemplates, {
    onSuccess: (response) => {
      if (response && response.status === 200) {
        setTemplates(response.data.taskCounterTemplateDtos);
        setTotalRecords(response.data.totalRecords);
      }
    },
    onError: () => {},
  });

  return {
    templates,
    totalRecords,
    setTemplates,
    setTotalRecords,
    mutationQueryTemplates,
  };
};
